import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewDeleteIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.47132 1.47157C9.73167 1.21122 9.73167 0.789108 9.47132 0.528758C9.21097 0.268409 8.78886 0.268409 8.52851 0.528758L4.99992 4.05735L1.47132 0.528758C1.21097 0.268409 0.788864 0.268409 0.528514 0.528758C0.268165 0.789108 0.268165 1.21122 0.528514 1.47157L4.05711 5.00016L0.528514 8.52876C0.268165 8.78911 0.268165 9.21122 0.528514 9.47157C0.788864 9.73192 1.21097 9.73192 1.47132 9.47157L4.99992 5.94297L8.52851 9.47157C8.78886 9.73192 9.21097 9.73192 9.47132 9.47157C9.73167 9.21122 9.73167 8.78911 9.47132 8.52876L5.94273 5.00016L9.47132 1.47157Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgNewDeleteIcon);
export { ForwardRef as ReactComponent };
